import { UserFormWidget } from "../../../widgets/user-form/ui/UserFormWidget";

export const UserCreatePage = () => <UserFormWidget />;
